import { addDays, startOfWeek } from 'date-fns';
import { weekdaysNumberMap } from 'shared/constants';
import { WeekDays } from 'shared/types/week-days';

export const getNextWeekStart = (date: Date, weekStartsOn: WeekDays) =>
  startOfWeek(addDays(date, 7), {
    weekStartsOn: weekdaysNumberMap[weekStartsOn],
  });
